export const shortString = (str, maxChar) => {
    if (str.length <= maxChar) return str;

    return str.slice(0, maxChar - 3) + '...';
};
